import { render, staticRenderFns } from "./goodBehaviorDetail.vue?vue&type=template&id=64b933be&scoped=true"
import script from "./goodBehaviorDetail.vue?vue&type=script&lang=js"
export * from "./goodBehaviorDetail.vue?vue&type=script&lang=js"
import style0 from "./goodBehaviorDetail.vue?vue&type=style&index=0&id=64b933be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b933be",
  null
  
)

export default component.exports